import { render, staticRenderFns } from "./seckillSetting.vue?vue&type=template&id=4bd491fb&scoped=true&"
import script from "./seckillSetting.vue?vue&type=script&lang=js&"
export * from "./seckillSetting.vue?vue&type=script&lang=js&"
import style0 from "./seckillSetting.vue?vue&type=style&index=0&id=4bd491fb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd491fb",
  null
  
)

export default component.exports